<template>
  <div class="renter-content">
    <div class="content-box renter-contact">
      <div class="table-bd">
        <div class="contact-title" style="margin-bottom: 16px;">
          <el-button type="primary" icon="el-icon-plus" @click="addContact()">
            {{
              $t('crm_renter-contact.xin_zeng_lian_xi_ren')
            }}
          </el-button>
        </div>
        <custom-table
          :data="coopcontactList"
          :loading="isLoading"
          :column="tableColumn"
          @filter="filterChange"
          @sort="sortChange"
          :slots="[ 'action']"
        >
          <!-- 操作列 -->
            <template slot="action" slot-scope="scope">
              <span></span>
              <el-button
                type="text"
                size="mini"
                @click="editContact(scope.row)"
              >{{$t('Common.com_edit')}}</el-button>
              <el-button
                type="text"
                size="mini"
                @click="deleteContact(scope.row.contactId)"
              >{{$t('Common.com_delete')}}</el-button>
            </template>
        </custom-table>
        <div class="contact-title" style="margin:16px 0px;">
          <el-button type="primary" icon="el-icon-plus" @click="addContactBusleader()">{{$t('crm_renter-contact.xzxmfzr')}}</el-button>
        </div>
        <div class="title" v-if="busleaderList.length">{{$t('crm_renter-contact.xmfzrxx')}}</div>
        <custom-table
          :data="busleaderList"
          :loading="isLoading"
          :column="tableColumn"
          @filter="filterChange"
          @sort="sortChange"
          :slots="['post', 'action']"
        >
          <template v-slot:post="">
            <span>{{$t('crm_renter-contact.xiang_mu_fu_ze_ren')}}</span>
          </template>
          <!-- 操作列 -->
            <template slot="action" slot-scope="scope">
              <span></span>
              <el-button
                type="text"
                size="mini"
                @click="editContactBusleader(scope.row)"
              >{{$t('Common.com_edit')}}</el-button>
              <el-button
                type="text"
                size="mini"
                @click="deleteContactBusleader(scope.row.contactId)"
              >{{$t('Common.com_delete')}}</el-button>
            </template>
        </custom-table>
        <div class="contact-title" style="margin:16px 0px;">
          <el-button type="primary" icon="el-icon-plus" v-if="!financerList.length" @click="addContactFinancer()">{{$t('crm_renter-contact.xzcwfzr')}}</el-button>
        </div>
        <div class="title" v-if="financerList.length">{{$t('crm_renter-contact.cwfzrxx')}}</div>
        <custom-table
          :data="financerList"
          :loading="isLoading"
          :column="tableColumn"
          @filter="filterChange"
          @sort="sortChange"
          :slots="['post', 'action']"
        >
          <template v-slot:post="">
            <span>{{$t('crm_renter-contact.cai_wu_fu_ze_ren')}}</span>
          </template>
          <!-- 操作列 -->
          <template slot="action" slot-scope="scope">
              <span></span>
              <el-button
                type="text"
                size="mini"
                @click="editContactFinancer(scope.row)"
              >{{$t('Common.com_edit')}}</el-button>
              <el-button
                type="text"
                size="mini"
                @click="deleteContactFinancer(scope.row.contactId)"
              >{{$t('Common.com_delete')}}</el-button>
          </template>
        </custom-table>
      </div>
    </div>
     <div class="btn-group">
      <!-- <el-button @click="onCancel">取消</el-button> -->
      <el-button @click="$emit('previous');">{{$t('crm_renter-contact.sybjbxx')}}</el-button>
      <!-- <el-button type="primary" @click="preStep">上一步,基本信息</el-button> -->
      <el-button type="primary" @click="nextContacts">{{$t('crm_renter-contact.xybglyxx')}}</el-button>
    </div>
    <renter-contacts-dialog
      v-if="dialogVisible"
      :model="dialogModel"
      @close="dialogVisible = false"
      @success="getContactList"
    >
    </renter-contacts-dialog>
    <renter-contactsBusiness-dialog
      v-if="dialogVisible1"
      :model="dialogModel1"
      @close="dialogVisible1 = false"
      @success="getContactList"
    >
    </renter-contactsBusiness-dialog>
    <renter-contactsFinance-dialog
      v-if="dialogVisible2"
      :model="dialogModel2"
      @close="dialogVisible2 = false"
      @success="getContactList"
    >
    </renter-contactsFinance-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import renterContactsDialog from './renter_contacts_dialog.vue';
import renterContactsBusinessDialog from './renter_contactsBusiness_dialog.vue';
import renterContactsFinanceDialog from './renter_contactsFinance_dialog.vue';

export default {
  components: {
    renterContactsDialog,
    renterContactsBusinessDialog,
    renterContactsFinanceDialog
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      }
    },
    partnerId: [String, Number],
    partnerOrgId: [String, Number],
    required: { type: Boolean, default: false }
  },
  data() {
    return {
      tableCode: 'company_contact',
      // 合同类型
      // 操作
      visibleSet: '',
      dialogSetData: {},
      contactList: [],

      coopcontactList: [],
      busleaderList: [],
      financerList: [],

      // 联系人弹窗
      dialogVisible: false,
      dialogModel: {},
      // 业务联系人弹窗
      dialogVisible1: false,
      dialogModel1: {},
      // 财务联系人弹窗
      dialogVisible2: false,
      dialogModel2: {},
    };
  },

  mounted() {
    this.getTableColumn();
    this.getContactList();
  },

  methods: {
    getContactList: function () {
      if (!this.partnerId) {
        return;
      }
      this.$getJSON(apis.partnerContact, {
        partnerId: this.partnerId,
        partnerOrgId: this.partnerOrgId
      }).then((res) => {
        this.contactList = res.data || [];
        // contactType: 'coopcontact'
        this.coopcontactList = this.contactList.filter(i => i.contactType === 'coopcontact');
        this.busleaderList = this.contactList.filter(i => i.contactType === 'busleader');
        this.financerList = this.contactList.filter(i => i.contactType === 'financer');
      });
    },
    // 新增联系人
    addContact() {
      const title = this.$t('crm_renter-contact.xin_zeng_lian_xi_ren');
      this.dialogModel.data = {
        partnerId: this.partnerId,
        partnerOrgId: this.partnerOrgId
      };
      this.dialogModel.title = title;
      this.dialogModel.type = 'add';
      this.dialogVisible = true;
    },
    // 编辑联系人
    editContact(item) {
      const title = this.$t('crm_renter-contact.xiu_gai_lian_xi_ren');
      this.dialogModel.data = item;
      this.dialogModel.title = title;
      this.dialogModel.type = 'edit';
      this.dialogVisible = true;
    },
    deleteContact: function (contactId) {
      const tips = this.$t('crm_renter-contact.nqdysclxrm');
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(`${apis.partnerContactDelete}/${contactId}`,).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success'
            });
            this.getContactList();
          });
        })
        .catch(() => {});
    },
    // 新增业务员
    addContactBusleader() {
      const title = this.$t('crm_renter-contact.xzxmfzr');
      this.dialogModel1.data = {
        partnerId: this.partnerId,
        partnerOrgId: this.partnerOrgId
      };
      this.dialogModel1.title = title;
      this.dialogModel1.type = 'add';
      this.dialogVisible1 = true;
    },
    // 编辑业务员
    editContactBusleader(item) {
      const title = this.$t('crm_renter-contact.bjxmfzr');
      this.dialogModel1.data = item;
      this.dialogModel1.title = title;
      this.dialogModel1.type = 'edit';
      this.dialogVisible1 = true;
    },
    deleteContactBusleader: function (contactId) {
      const tips = this.$t('crm_renter-contact.nqdyscxmfzrm');
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(`${apis.partnerContactDelete}/${contactId}`,).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success'
            });
            this.getContactList();
          });
        })
        .catch(() => {});
    },
    // 新增财务
    addContactFinancer() {
      const title = this.$t('crm_renter-contact.xzcwfzr');
      this.dialogModel2.data = {
        partnerId: this.partnerId,
        partnerOrgId: this.partnerOrgId
      };
      this.dialogModel2.title = title;
      this.dialogModel2.type = 'add';
      this.dialogVisible2 = true;
    },
    // 编辑财务
    editContactFinancer(item) {
      const title = this.$t('crm_renter-contact.bjcwfzr');
      this.dialogModel2.data = item;
      this.dialogModel2.title = title;
      this.dialogModel2.type = 'edit';
      this.dialogVisible2 = true;
    },
    deleteContactFinancer: function (contactId) {
      const tips = this.$t('crm_renter-contact.nqdysccwfzrm');
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(`${apis.partnerContactDelete}/${contactId}`,).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success'
            });
            this.getContactList();
          });
        })
        .catch(() => {});
    },
    // 下一步
    nextContacts: function () {
      if (!this.coopcontactList.length && this.required) {
        this.$message({
          message: this.$t('crm_renter-contact.qtjlxr'),
          type: 'error',
        });
        return;
      }
      if (!this.busleaderList.length && this.required) {
        this.$message({
          message: this.$t('crm_renter-contact.qtjxmfzr'),
          type: 'error',
        });
        return;
      }
      if (!this.financerList.length && this.required) {
        this.$message({
          message: this.$t('crm_renter-contact.qtjcwfzr'),
          type: 'error',
        });
        return;
      }
      this.$emit('success', 3);
    },
  }
};
</script>

<style lang="scss">
@import "style/colors.scss";
.renter-content {
  height: 100%;
  // position: relative;
  // overflow: auto;
  display: flex;
  // padding:  0 24px;
      padding: 24px;
  flex-direction: column;
  background: #fff;
  box-sizing: border-box;

  .renter-contact {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 0 24px;
    overflow-y: auto;
    .table-bd{
      overflow-y: auto;
      .title {
        color: #0d9ae0;
        font-weight: bold;
        line-height: 16px;
        margin: 24px 0;
        font-size: 12px;
      }
    }

  }
  }

</style>
